import * as React from 'react';
import { formatDollar } from 'helpers/formatters';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { IconButton, Typography } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';

export const columnDefs = (onDBBRefresh: (locationId: string) => void) => [
    {
        headerName: 'Location Name',
        field: 'locationName',
        cellStyle: { textAlign: 'left' },
    },
    {
        headerName: 'Zone',
        field: 'zone',
    },
    {
        headerName: 'TIV',
        field: 'tiv',
        type: 'numericColumn',
        valueFormatter: ({ value }: any) => formatDollar(value, 0),
    },
    {
        headerName: 'Base Rate',
        field: 'baseRate',
        type: 'numericColumn',
    },
    {
        headerName: 'CR/DB',
        field: 'CR_DB',
        type: 'numericColumn',
        valueFormatter: ({ value }: any) => (value ?? 0) + '%',
    },
    {
        headerName: 'Final Rate',
        field: 'finalRate',
        type: 'numericColumn',
    },
    {
        headerName: 'Premium',
        field: 'totalPremium',
        type: 'numericColumn',
        valueFormatter: ({ value }: any) => formatDollar(value, 0),
    },
    {
        headerName: 'DBB Premium',
        field: 'dedBBPremium',
        type: 'numericColumn',
        cellRenderer: (params: ICellRendererParams) => {
            return (
                <>
                    {params.value >= 0 ? formatDollar(params.value, 0) : '--'}
                    <IconButton size={'small'} onClick={() => onDBBRefresh(params.data.locationId)}>
                        <SyncIcon />
                    </IconButton>
                </>
            );
        },
    },
    {
        headerName: 'Lumen Rating',
        field: 'lumenRating',
        type: 'numericColumn',
        valueFormatter: ({ value }: any) => value || '--',
    },
];

export const defaultColDef = {
    resizable: true,
    sortable: false,
    filter: false,
};
